import React, { useEffect, useState } from "react";
import Modal from "react-animated-modal";
import CustomScroll from "react-custom-scroll";
import { LongDateFormat } from "../../constants/DateFormatters";

function AnnouncementsModal(props) {
  const announcementType =
    props.announcement &&
    (props.announcement.announcementType === 0
      ? "important"
      : props.announcement.announcementType === 1
      ? "warning"
      : "information");

  return (
    <Modal visible={true} type="fadeIn" closemodal={props.openCloseModal}>
      <div className="modal" role="dialog">
        <div className="announcement-modal">
          <div className="modal" tabIndex="-1" role="dialog">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className={"modal-header-" + announcementType}>
                  <div className="announcement-title">
                    {props.announcement.title}
                    <button className="btn">
                      <i
                        className="icon-omni-close-circle"
                        onClick={props.openCloseModal}
                      />
                    </button>
                  </div>
                </div>
                <CustomScroll
                  heightRelativeToParent="50%"
                  allowOuterScroll={false}
                >
                  <div className="modal-body">
                    <div className="announcement-area">
                      <div className="announcement-date-area">
                        <div className={announcementType}>
                          <i className="icon-omni-warning-circle" />
                          <span>
                            <b>
                              {props._.Expires + ": "} {""}
                            </b>
                            {LongDateFormat(
                              props.announcement.broadcastEndDate,
                              props._.MomentLang
                            )}
                          </span>
                        </div>
                      </div>
                      <div className="announcement-context">
                        <div className="message">
                          {props.announcement.message}
                        </div>
                        <div className="published">
                          <div className="text">{props._.Published}:</div>
                          <div className="date">
                            {LongDateFormat(
                              props.announcement.broadcastStartDate,
                              props._.MomentLang
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </CustomScroll>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default AnnouncementsModal;
